export default function createManualReadingsWorker() {
    return new Worker(new URL('./manualReadings.worker.js',import.meta.url));
}
